import React, {Component} from "react";
import {
  HREF_PAGE_HOME,
  STATUS_FAILED,
  STATUS_SUCCESS,
  USER_TYPE_SECRETARY,
  PAYMENT_METHOD_BANK_TRANSFER_ARS,
  PAYMENT_METHOD_MERCADO_PAGO_ARS,
  PAYMENT_METHOD_PAYPAL_USD,
  PAYMENT_METHOD_BANK_TRANSFER_USD
} from "../../models/constants";
import AuthService from "../../modules/authService";
import APIService from "../../modules/apiService";
import Helpers from "../../modules/helpers";
import locales_es from "../../locales/es";
import Spinner from "../../components/spinner";
import "./styles.css";
import Loading from "../../components/loading";
import ModalAnimationResult from "../../components/modalAnimationResult";
import Form from "../../components/form";
import ViewHelpers from "../../modules/viewHelpers";
import ConfigService from "../../modules/configService";

export default class ClinicSettingsPage extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      selectedTab: this.getPreselectedTab(),
      loading: true,
      postServiceId: null, // usamos esto para saber si es la primera vez que el usuario configura esto
      // porque si es la primera vez, hay que hacer POST, y se puede hacer DELETE, pero sino, hay que hacer PUT
      // Lo inicio en null por si necesito saber más adelante si esto se pisó, o quedó en null
      enabledPostService: false,
      // appointment_status: 'completed', // Solo esto por ahora. Lo comento porque no lo estamos usando.
      // delivery_medium: 'email', // Solo esto por ahora. Lo comento porque no lo estamos usando.
      hours_after_appointment: 72,
      subject: '',
      message: '',
      paymentMethods: null,
      enableBeforePayment: null,
      mercadoPagoEnabled: null,
      mercadoPagoData: null,
      currentPaymentMethods: [],
      bankTransferData: '',
      bankTransferDataUSD: '',
      currencies: null,
      paypalCredentials: null,
      userData: null,
      notification_enable_send_confirmation: false,
      notification_reminder_channel: 'email_and_whatsapp',
      notification_days_reminder: 1,
      notification_enable_cancel_appointment: false,
      name: '',
      description: '',
      web_url: '',
      brand_color: '#000000',
      text_brand_color: '#000000',
      primary_color: '#000000',
      text_primary_color: '#000000',
      secondary_color: '#000000',
      text_secondary_color: '#000000',
    };
    
    this.auth = new AuthService();
    this.api = new APIService();
    this.helpers = new Helpers();
    this.viewHelpers = new ViewHelpers();
    this.configService = new ConfigService();
    
    if (window.URLSearchParams && new window.URLSearchParams(this.props.location.search).get("result")) {
      setTimeout(() => {
        this.setState({
          result: new window.URLSearchParams(this.props.location.search).get("result")
        })
      }, 1500);
    }
  }
  
  componentWillMount() {
    this.checkUserAllowed();
  }
  
  componentDidMount() {
    if (this.state.selectedTab) {
      const anchor = document.getElementById(`a-tab${this.state.selectedTab}`);
      if (anchor) {
        anchor.click();
      }
    }
  }
  
  async checkUserAllowed() {
    const allowed = await this.viewHelpers.isUserAllowed(USER_TYPE_SECRETARY);
    allowed ? this.load() : this.redirectNotLoggedIn();
  }
  
  getPreselectedTab() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlTab = urlParams.get('tab');
    if (urlTab) {
      return urlTab;
    }
    
    const storedTab = localStorage.getItem('tab');
    if (storedTab) {
      return storedTab;
    }
  }
  
  saveTabToLocalStorage(tabValue) {
    localStorage.setItem('tab', tabValue);
  }
  
  handleTabClick = (event) => {
    // Previene el comportamiento predeterminado del enlace
    event.preventDefault();
    
    // Obtiene el valor del href y extrae el número del tab
    const tabNumber = event.currentTarget.getAttribute('href').split('#tab')[1];
    
    // Llama a saveTabToLocalStorage con el número del tab
    this.saveTabToLocalStorage(tabNumber);
  }
  
  setLoading(bool) {
    this.setState({
      loading: bool
    })
  }
  
  load() {
    this.setLoading(true);
    this.configService.getRemoteClinicData().then((config) => {
      this.setState({
        clinicId: config.id,
        clinicConfig: config,
        notification_enable_send_confirmation: !!config.notification_enable_send_confirmation,
        notification_reminder_channel: config.notification_reminder_channel || 'email_and_whatsapp',
        notification_days_reminder: config.notification_days_reminder || 1,
        notification_enable_cancel_appointment: !!config.notification_enable_cancel_appointment,
        name: config.name || '',
        description: config.description || '',
        web_url: config.web_url || '',
        brand_color: config.brand_color || '#000000',
        text_brand_color: config.text_brand_color || '#000000',
        primary_color: config.primary_color || '#000000',
        text_primary_color: config.text_primary_color || '#000000',
        secondary_color: config.secondary_color || '#000000',
        text_secondary_color: config.text_secondary_color || '#000000',
      }, () => {
        this.api.getCurrencies().then(res => {
          this.setState({
            currencies: res.data
          })
        }).catch(err => {
          this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        })
        this.api.getPaymentMethods().then(res => {
          if (res && res.data) {
            this.setState({
              paymentMethods: res.data
            }, () => {
              this.loadUserData();
              this.getMercadoPagoStatus();
              this.getBankTransferInfo();
              this.getPaypalStatus();
              this.getBankTransferUSDInfo();
            });
          }
        }).catch(err => {
          this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        });
        
        this.api.getPostsServicesMessages(this.state.clinicId).then(res => {
          if (res && res.data) {
            this.setState({
              enabledPostService: true,
              postServiceId: res.data.id,
              hours_after_appointment: res.data.hours_after_appointment,
              subject: res.data.subject,
              message: res.data.message,
            })
          } else {
            this.setState({
              postServiceId: null, // por si viene de un refresh después de un DELETE
            })
          }
          this.setLoading(false);
        }).catch(err => {
          this.setLoading(false);
          this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        })
      })
    }).catch(err => {
      console.log(err)
    })
  }
  
  redirectNotLoggedIn() {
    window.location.href = HREF_PAGE_HOME;
  }
  
  handleChange = state => ev => {
    this.setState({[state]: ev.target.value});
  };
  
  handleReactSelectChange = state => value => {
    this.setState({[state]: value});
  };
  
  savePostService() {
    const objData = {
      clinic_id: this.state.clinicId,
      hours_after_appointment: this.state.hours_after_appointment,
      subject: this.state.subject,
      message: this.state.message,
    }
    this.setLoading(true);
    if (this.state.postServiceId) {
      this.api.putPostsServicesMessages(this.state.postServiceId, objData).then(res => {
        this.props.showMainModal(locales_es.successModal.title, res.message);
        this.load();
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        this.setLoading(false);
      })
    } else {
      this.api.postPostsServicesMessages(objData).then(res => {
        this.props.showMainModal(locales_es.successModal.title, res.message);
        this.load();
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        this.setLoading(false);
      })
    }
  }
  
  deletePostService() {
    this.setLoading(true);
    this.api.deletePostsServicesMessages(this.state.postServiceId).then(res => {
      this.props.showMainModal(locales_es.successModal.title, res.message);
      this.load();
    }).catch(err => {
      this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
      this.setLoading(false);
    })
  }
  
  loadUserData() {
    this.auth.getRemoteUserData().then(res => {
      this.setState({
        userData: res.data.user,
      }, () => {
        this.api.getPaymentConfig().then(res => {
          this.setState({
            enableBeforePayment: res.data.enable_before_payment,
          }, () => {
            this.loadUserPaymentMethods();
            this.setLoading(false);
          });
        }).catch(err => {
          this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        });
      });
    }).catch(err => {
      this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
    })
  }
  
  loadUserPaymentMethods() {
    this.api.getPaymentMethodsByUser(this.state.userData.id).then(res => {
      const arr = res.data;
      this.setState({
        currentPaymentMethods: arr.map(pm => pm.payment_method.id)
      })
    }).catch(err => {
      this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
    });
  }
  
  PMIndexInArray(pmId) {
    return this.state.currentPaymentMethods.indexOf(pmId);
  }
  
  getBankTransferInfo() {
    this.api.getBankTransfer().then(res => {
      if (res.data) {
        this.setState({
          bankTransferData: res.data.data
        })
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  
  getBankTransferUSDInfo() {
    this.api.getBankTransferUSD().then(res => {
      if (res.data) {
        this.setState({
          bankTransferDataUSD: res.data.data
        })
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  
  getMercadoPagoStatus() {
    this.api.getMercadoPagoInfo().then((res) => {
      this.setMercadoPagoEnabled(true);
      this.setState({
        mercadoPagoData: res.data
      });
    }).catch(() => {
      this.setMercadoPagoEnabled(false);
    })
  }
  
  getPaypalStatus() {
    this.api.getPaypalInfo().then((res) => {
      this.setState({
        paypalCredentials: res.data
      });
    }).catch((err) => {
      console.log(err);
      this.setState({
        paypalCredentials: false
      });
    })
  }
  
  setPaypalCredentials(key, value) {
    const paypalCredentials = JSON.parse(JSON.stringify(this.state.paypalCredentials));
    paypalCredentials[key] = value;
    this.setState({
      paypalCredentials
    });
  }
  
  setMercadoPagoEnabled(bool) {
    this.setState({
      mercadoPagoEnabled: bool
    })
  }
  
  render() {
    const {
      loading,
      result,
      enabledPostService,
    } = this.state;
    
    const postServiceInputs = [
      {
        label: locales_es.postServiceTimelapseText,
        placeholder: locales_es.postServiceTimelapseTextPlaceholder,
        id: 1,
        state: 'hours_after_appointment',
        value: this.state.hours_after_appointment,
        type: 'number',
        required: true,
        min: 1,
        wrapperCustomClassName: 'float-left',
      },
      {
        label: locales_es.postServiceSubjectText,
        placeholder: locales_es.postServiceSubjectTextPlaceholder,
        id: 2,
        state: 'subject',
        value: this.state.subject,
        type: 'text',
        required: true,
        wrapperCustomClassName: 'form-group clear',
      },
      {
        label: locales_es.postServiceMessageText,
        placeholder: locales_es.postServiceMessageTextPlaceholder,
        id: 3,
        state: 'message',
        value: this.state.message,
        type: 'textarea',
        required: true,
        wrapperCustomClassName: 'form-group clear',
      },
    ];
    
    const toggleEnabledPostService = () => {
      const toggle = !this.state.enabledPostService;
      this.setState({
        enabledPostService: toggle,
      }, () => {
        if (this.state.postServiceId) {
          if (toggle === true) {
            this.savePostService();
          }
          if (toggle === false) {
            this.deletePostService();
          }
        }
      });
    }
    
    const {
      paymentMethods,
      userData,
      enableBeforePayment,
      mercadoPagoEnabled,
      mercadoPagoData,
      currencies,
      paypalCredentials,
    } = this.state;
    
    const onChangeEnableBeforePayment = () => {
      this.setState({
        enableBeforePayment: !enableBeforePayment
      })
    };
    
    const savePaymentMethods = () => {
      sendConfig({enable_before_payment: enableBeforePayment}, enableBeforePayment);
    };
    
    const sendConfig = (objData, sendPM) => {
      this.setLoading(true);
      this.api.putPaymentConfig(objData).then((res) => {
        if (sendPM) {
          sendPaymentMethods();
        } else {
          this.props.showMainModal(locales_es.successModal.title, res.message);
          this.setLoading(false);
        }
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        this.setLoading(false);
      });
    };
    
    const sendPaymentMethods = () => {
      this.setLoading(true);
      this.api.putBankTransferUSDData({data: this.state.bankTransferDataUSD}).then(() => {
        this.api.putBankTransferData({data: this.state.bankTransferData}).then(() => {
          sendPaypalCredentials();
        }).catch(err => {
          this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
          this.setLoading(false);
        });
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        this.setLoading(false);
      });
    };
    
    const sendPaypalCredentials = () => {
      if (this.state.paypalCredentials) {
        this.api.putPaypalData(this.state.paypalCredentials).then(() => {
          confirmPaymentMethods();
        }).catch(err => {
          this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
          confirmPaymentMethods();
        })
      } else {
        confirmPaymentMethods();
      }
    }
    
    const confirmPaymentMethods = () => {
      this.api.putPaymentMethods({payment_methods: this.state.currentPaymentMethods}).then(res => {
        this.props.showMainModal(locales_es.successModal.title, res.message);
        this.load();
        this.setLoading(false);
      }).catch((err) => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        this.setLoading(false);
      })
    }
    
    const onClickCheckbox = (e, pm) => {
      if (!enableBeforePayment) {
        e.preventDefault();
      }
      if (pm.tag === PAYMENT_METHOD_MERCADO_PAGO_ARS && !mercadoPagoEnabled) {
        this.props.showMainModal(locales_es.infoModal.title, 'Debe vincular primero una cuenta Mercado Pago para poder usar este medio de cobro');
        return;
      }
      
      const paymentMethods = JSON.parse(JSON.stringify(this.state.currentPaymentMethods));
      const index = this.PMIndexInArray(pm.id);
      if (index >= 0) {
        paymentMethods.splice(index, 1);
        this.setState({
          currentPaymentMethods: paymentMethods
        })
      } else {
        paymentMethods.push(pm.id);
        this.setState({
          currentPaymentMethods: paymentMethods
        })
      }
    };
    
    const onClickLinkMercadoPago = () => {
      this.api.getMercadoPagoAuthorizationLink(window.location.origin).then(res => {
        this.loadUserData();
        window.location.href = res.data.url;
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
      })
    };
    
    const onClickUnlinkMercadoPago = () => {
      this.props.showMainModal('Desvincular cuenta de Mercado Pago', '¿Está seguro de desvincular su cuenta de Mercado Pago?', null, [
        {
          label: 'Sí, desvincular',
          class: 'btn btn-danger btn-elevate btn-pill btn-sm',
          method: () => {
            this.api.deleteMercadoPagoAuthorization().then(res => {
              this.props.showMainModal(locales_es.successModal.title, res.message);
              this.setState({
                mercadoPagoEnabled: false
              }, () => {
                this.loadUserData();
              })
            }).catch(err => {
              this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
            })
          }
        },
        {
          label: 'No, no desvincular',
          class: 'btn btn-primary btn-elevate btn-pill btn-sm'
        }
      ]);
    };
    
    const onBlurBankTransferTextarea = (pmId) => {
      if (this.PMIndexInArray(pmId) >= 0 && !this.state.bankTransferData) {
        this.props.showMainModal(locales_es.infoModal.title, 'Debes completar la información adicional en el campo de texto para activar el cobro mediante Transferencia Bancaria en Pesos Argentinos.');
      }
    };
    
    const onBlurBankTransferUSDTextarea = (pmId) => {
      if (this.PMIndexInArray(pmId) >= 0 && !this.state.bankTransferDataUSD) {
        this.props.showMainModal(locales_es.infoModal.title, 'Debes completar la información adicional en el campo de texto para activar el cobro mediante Transferencia Bancaria en USD.');
      }
    };
    
    const saveNotifications = () => {
      const data = {
        name: this.state.name,
        notification_enable_send_confirmation: this.state.notification_enable_send_confirmation ? 1 : 0,
        notification_reminder_channel: this.state.notification_reminder_channel,
        notification_days_reminder: this.state.notification_days_reminder,
        notification_enable_cancel_appointment: this.state.notification_enable_cancel_appointment ? 1 : 0,
      };
      this.setLoading(true);
      this.configService.updateRemoteClinicData(this.state.clinicId, {...this.state.clinicConfig, ...data}).then(res => {
        this.props.showMainModal(locales_es.successModal.title, res.message);
        this.load();
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        this.setLoading(false);
      })
    };
    
    const saveMeta = () => {
      const data = {
        name: this.state.name,
        description: this.state.description,
        web_url: this.state.web_url,
      };
      this.setLoading(true);
      this.configService.updateRemoteClinicData(this.state.clinicId, {...this.state.clinicConfig, ...data}).then(res => {
        this.props.showMainModal(locales_es.successModal.title, res.message);
        // this.load();
        this.configService.refreshClinicData();
        this.setLoading(false);
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        this.setLoading(false);
      })
    };
    
    const saveColors = () => {
      const data = {
        name: this.state.name,
        description: this.state.description,
        web_url: this.state.web_url,
        brand_color: this.state.brand_color,
        text_brand_color: this.state.text_brand_color,
        primary_color: this.state.primary_color,
        text_primary_color: this.state.text_primary_color,
        secondary_color: this.state.secondary_color,
        text_secondary_color: this.state.text_secondary_color,
      };
      this.setLoading(true);
      this.configService.updateRemoteClinicData(this.state.clinicId, {...this.state.clinicConfig, ...data}).then(res => {
        this.props.showMainModal(locales_es.successModal.title, res.message);
        // this.load();
        this.configService.refreshClinicData();
        this.setLoading(false);
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        this.setLoading(false);
      })
    };
    
    const resetColors = () => {
      const data = {
        name: this.state.name,
        description: this.state.description,
        web_url: this.state.web_url,
        brand_color: null,
        text_brand_color: null,
        primary_color: null,
        text_primary_color: null,
        secondary_color: null,
        text_secondary_color: null,
      };
      this.setLoading(true);
      this.configService.updateRemoteClinicData(this.state.clinicId, {...this.state.clinicConfig, ...data}).then(res => {
        this.props.showMainModal(locales_es.successModal.title, res.message);
        this.configService.refreshClinicData();
        window.location.reload();
      }).catch(err => {
        this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
        this.setLoading(false);
      })
    };
    
    return (
      <div className="kt-portlet kt-portlet--height-fluid kt-widget-17">
        {loading ? <Loading/> : null}
        <div className="row">
          <div className="col-12">
            
            <div className="kt-portlet kt-portlet--tabs m-0">
              <div className="kt-portlet__head">
                <div className="kt-portlet__head-label d-none d-lg-flex">
                  <h3 className="kt-portlet__head-title">
                    {locales_es.clinicSettings}
                  </h3>
                </div>
                <div className="kt-portlet__head-toolbar">
                  <ul className="nav nav-tabs nav-tabs-line nav-tabs-line-brand nav-tabs-bold"
                      role="tablist">
                    <li className="nav-item">
                      <a className="nav-link show active" data-toggle="tab" onClick={this.handleTabClick}
                         href="#tab1" id="a-tab1" role="tab" aria-selected="true">
                        {locales_es.mailing}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link show" data-toggle="tab" onClick={this.handleTabClick}
                         href="#tab2" id="a-tab2" role="tab" aria-selected="true">
                        {locales_es.paymentMethods}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link show" data-toggle="tab" onClick={this.handleTabClick}
                         href="#tab3" id="a-tab3" role="tab" aria-selected="true">
                        {locales_es.reminders}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link show" data-toggle="tab" onClick={this.handleTabClick}
                         href="#tab4" id="a-tab4" role="tab" aria-selected="true">
                        {locales_es.globalConfigurations}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="kt-portlet__body">
                <div className="tab-content">
                  <div className="tab-pane fade active show" id="tab1" role="tabpanel">
                    
                    <div className="row mt-3">
                      <div className="col">
                        <label className="kt-checkbox">
                          <input type="checkbox"
                                 onChange={toggleEnabledPostService}
                                 checked={enabledPostService}/>
                          <span/> Habilitar mensajes automáticos para turnos atendidos
                        </label>
                      </div>
                    </div>
                    
                    {enabledPostService &&
                      <div className="kt-portlet">
                        <div className="row mt-5 pt-3">
                          <div className="col text-center">
                            <h3>{locales_es.enablePostServiceTitle}</h3>
                            <p>{locales_es.enablePostServiceDescription}</p>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col text-center">
                            <Form
                              styles="kt-form"
                              inputs={postServiceInputs}
                              handleChange={this.handleChange}
                              wrapper={true}
                              onSubmit={() => this.savePostService()}
                            />
                          </div>
                        </div>
                      </div>
                    }
                  
                  </div>
                  <div className="tab-pane fade" id="tab2" role="tabpanel">
                    {currencies === null ? <Spinner/> :
                      currencies && currencies.length ?
                        <div className="kt-portlet--tabs m-0">
                          <div className="row mt-3">
                            <div className="col">
                              <label className="kt-checkbox">
                                <input type="checkbox" id="enable-before-payment"
                                       onChange={onChangeEnableBeforePayment}
                                       checked={enableBeforePayment}/>
                                <span/> Habilitar cobro online
                              </label>
                              {enableBeforePayment && (
                                <div class="alert alert-secondary" role="alert">
                                  <div class="alert-icon"><i class="flaticon-questions-circular-button"></i></div>
                                  <div class="alert-text">Con esta configuración, el TEAM procesa todos los cobros,
                                    pisando las configuraciones individuales que tengan los usuarios médicos.
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="kt-portlet__head">
                            <div className="kt-portlet__head-toolbar">
                              <ul className="nav nav-tabs nav-tabs-line nav-tabs-line-brand nav-tabs-bold"
                                  role="tablist">
                                {currencies.map((currency, index) =>
                                  <li key={`li-tab-currencies-${currency.id}`} className="nav-item">
                                    <a className={`nav-link show ${index === 0 ? 'active' : ''}`} data-toggle="tab"
                                       href={`#tab-currencies-${currency.id}`} id={`a-tab-currencies-${currency.id}`}
                                       role="tab" aria-selected="true">
                                      {currency.id.toUpperCase()}
                                    </a>
                                  </li>)}
                              </ul>
                            </div>
                          </div>
                          <div className="kt-portlet__body">
                            <div className="tab-content">
                              {currencies.map((currency, index) =>
                                <div key={`pm-tab-currencies-${currency.id}`}
                                     className={`tab-pane fade ${index === 0 ? 'active show' : ''}`}
                                     id={`tab-currencies-${currency.id}`}
                                     role="tabpanel">
                                  {userData === null ? <Spinner/> :
                                    userData ?
                                      <>
                                        {paymentMethods === null ?
                                          <Spinner/>
                                          : paymentMethods && paymentMethods.length ?
                                            paymentMethods
                                              .filter((pm) => currency.enabled_payment_methods.includes(pm.tag))
                                              .map(pm =>
                                                <div key={pm.id}
                                                     className={`row mt-3 ml-3 border-top ${enableBeforePayment ? '' : 'disabled'}`}>
                                                  <div className="col">
                                                    <label className="kt-checkbox">
                                                      <input type="checkbox" id={pm.id}
                                                             onChange={(e) => onClickCheckbox(e, pm)}
                                                             checked={this.PMIndexInArray(pm.id) >= 0}
                                                             disabled={!enableBeforePayment}/>
                                                      <span></span>{locales_es.gatewayMethodsList[pm.tag]['label_' + userData.user_type]} {pm.tag === PAYMENT_METHOD_PAYPAL_USD &&
                                                      <a href="https://www.youtube.com/watch?v=k34cen4zxmA"
                                                         target="_blank">[Ver Video Tutorial]</a>}
                                                    </label>
                                                    {pm.tag === PAYMENT_METHOD_BANK_TRANSFER_ARS && this.PMIndexInArray(pm.id) >= 0 ?
                                                      <>
                                                        <br/>
                                                        <label className="float-right m-2">Información para la
                                                          transferencia
                                                          ({locales_es.required})</label>
                                                        <textarea className="form-control"
                                                                  disabled={!enableBeforePayment}
                                                                  onChange={(e) => this.setState({
                                                                    bankTransferData: e.target.value
                                                                  })}
                                                                  onBlur={() => onBlurBankTransferTextarea(pm.id)}
                                                                  defaultValue={this.state.bankTransferData}
                                                                  placeholder="Escribe aquí toda la información necesaria para que el paciente pueda realizar la transferencia correctamente"/>
                                                      </>
                                                      : null}
                                                    {pm.tag === PAYMENT_METHOD_MERCADO_PAGO_ARS ?
                                                      mercadoPagoEnabled === null ? <Spinner/>
                                                        :
                                                        <>
                                                          {mercadoPagoEnabled ? <div className="m-2">
                                                              <button type="button"
                                                                      disabled={!enableBeforePayment}
                                                                      onClick={onClickUnlinkMercadoPago}
                                                                      className="btn btn-danger btn-elevate btn-pill btn-sm m-sm-3 m-lg-0 ml-lg-3">Desvincular
                                                                Cuenta
                                                              </button>
                                                              {mercadoPagoData &&
                                                                <p className="mt-3">Cuenta
                                                                  vinculada: {mercadoPagoData.nickname}</p>
                                                              }
                                                            </div>
                                                            : <button type="button"
                                                                      onClick={onClickLinkMercadoPago}
                                                                      className="btn btn-info btn-elevate btn-pill btn-sm m-sm-3 m-lg-0 ml-lg-3">{locales_es.linkMercadoPagoAccount}</button>
                                                          }
                                                        </>
                                                      : null
                                                    }
                                                    {pm.tag === PAYMENT_METHOD_PAYPAL_USD && this.PMIndexInArray(pm.id) >= 0 ?
                                                      paypalCredentials === null ? <Spinner/>
                                                        :
                                                        paypalCredentials ?
                                                          <>
                                                            <br/>
                                                            <label className="float-right m-2">Client ID
                                                              ({locales_es.required})</label>
                                                            <input type="text"
                                                                   disabled={!enableBeforePayment}
                                                                   className="form-control"
                                                                   onChange={(e) => this.setPaypalCredentials('client_id', e.target.value)}
                                                                   value={this.state.paypalCredentials.client_id}
                                                                   placeholder="Escribe aquí el id de cliente de tu cuenta Paypal (Client ID)"/>
                                                            <label className="float-right m-2">Client Secret
                                                              ({locales_es.required})</label>
                                                            <input type="text"
                                                                   disabled={!enableBeforePayment}
                                                                   className="form-control"
                                                                   onChange={(e) => this.setPaypalCredentials('client_secret', e.target.value)}
                                                                   value={this.state.paypalCredentials.client_secret}
                                                                   placeholder="Escribe aquí el id de cliente de tu cuenta Paypal (Client ID)"/>
                                                          </>
                                                          : null
                                                      : null}
                                                    {pm.tag === PAYMENT_METHOD_BANK_TRANSFER_USD && this.PMIndexInArray(pm.id) >= 0 ?
                                                      <>
                                                        <br/>
                                                        <label className="float-right m-2">Información para la
                                                          transferencia en USD
                                                          ({locales_es.required})</label>
                                                        <textarea className="form-control"
                                                                  disabled={!enableBeforePayment}
                                                                  onChange={(e) => this.setState({
                                                                    bankTransferDataUSD: e.target.value
                                                                  })}
                                                                  onBlur={() => onBlurBankTransferUSDTextarea(pm.id)}
                                                                  defaultValue={this.state.bankTransferDataUSD}
                                                                  placeholder="Escribe aquí toda la información necesaria para que el paciente pueda realizar la transferencia correctamente"/>
                                                      </>
                                                      : null}
                                                  </div>
                                                </div>
                                              )
                                            :
                                            <div className="row">
                                              <div className="col">
                                                <h6 className="text-center">No hay métodos de pago habilitados</h6>
                                              </div>
                                            </div>
                                        }
                                      </>
                                      : null
                                  }
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        : <h1>Error: no se encontraron monedas activas.</h1>}
                    <div className="kt-portlet__foot kt-portlet__foot--md">
                      <div className="kt-widget-17__foot">
                        <div className="kt-widget-17__foot-info"/>
                        <div className="kt-widget-17__foot-toolbar">
                          <a href="#" onClick={(e) => {
                            e.preventDefault();
                            savePaymentMethods();
                          }}
                             className="btn btn-brand btn-sm btn-upper btn-bold">{locales_es.save}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="tab3" role="tabpanel">
                    <div class="form-group form-group-sm row">
                      <label className="col-xl-3 col-lg-3 col-form-label">Enviar confirmación de turno al
                        paciente</label>
                      <div class="col-lg-9 col-xl-6">
                            <span class="kt-switch">
                              <label>
                                <input type="checkbox"
                                       onChange={() => this.setState({notification_enable_send_confirmation: !this.state.notification_enable_send_confirmation})}
                                       checked={this.state.notification_enable_send_confirmation}/>
                                <span></span>
                              </label>
                            </span>
                      </div>
                    </div>
                    <div class="form-group form-group-sm row">
                      <label className="col-xl-3 col-lg-3 col-form-label">Mostrar botón de Cancelar Turno en el E-Mail de Recordatorio</label>
                      <div class="col-lg-9 col-xl-6">
                            <span class="kt-switch">
                              <label>
                                <input type="checkbox"
                                       onChange={() => this.setState({notification_enable_cancel_appointment: !this.state.notification_enable_cancel_appointment})}
                                       checked={this.state.notification_enable_cancel_appointment}/>
                                <span></span>
                              </label>
                            </span>
                      </div>
                    </div>
                    <div class="form-group form-group-sm row">
                      <label className="col-xl-3 col-lg-3 col-form-label">Canal recordatorio</label>
                      <div class="col-lg-9 col-xl-6">
                        <select className="form-control" value={this.state.notification_reminder_channel}
                                onChange={this.handleChange('notification_reminder_channel')}>
                          <option value="email_and_whatsapp">Por E-mail y WhatsApp</option>
                          <option value="email">Sólo por E-mail</option>
                          <option value="whatsapp">Sólo por WhatsApp</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group form-group-sm row">
                      <label className="col-xl-3 col-lg-3 col-form-label">Días previos recordatorio</label>
                      <div class="col-auto">
                        <input type="number" className="form-control" value={this.state.notification_days_reminder}
                               onChange={this.handleChange('notification_days_reminder')}/>
                      </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--md">
                      <div className="kt-widget-17__foot">
                        <div className="kt-widget-17__foot-info"/>
                        <div className="kt-widget-17__foot-toolbar">
                          <a href="#" onClick={(e) => {
                            e.preventDefault();
                            saveNotifications();
                          }} className="btn btn-brand btn-sm btn-upper btn-bold">{locales_es.save}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="tab4" role="tabpanel">
                    <div className="kt-section kt-section--first">
                      <h3 class="kt-section__title">Datos generales:</h3>
                      <Form
                        styles="kt-form row"
                        inputs={[
                          {
                            label: locales_es.name,
                            id: 1,
                            state: 'name',
                            value: this.state.name,
                            type: 'text',
                            required: true,
                            wrapperCustomClassName: 'form-group col-md-6'
                          },
                          {
                            label: locales_es.website,
                            id: 3,
                            state: 'web_url',
                            value: this.state.web_url,
                            type: 'text',
                            required: false,
                            wrapperCustomClassName: 'form-group col-md-6'
                          },
                          {
                            label: locales_es.description,
                            id: 2,
                            state: 'description',
                            value: this.state.description,
                            type: 'textarea',
                            required: false,
                            wrapperCustomClassName: 'form-group col-md-12'
                          },
                        ]}
                        handleChange={this.handleChange}
                        wrapper={true}
                        onSubmit={saveMeta}
                      />
                      <div
                        class="kt-separator kt-separator--border-dashed kt-separator--space-lg kt-separator--portlet-fit"></div>
                      <h3 class="kt-section__title">Colores:</h3>
                      <Form
                        styles="kt-form row"
                        inputs={[
                          {
                            label: 'Color Marca',
                            id: 4,
                            state: 'brand_color',
                            value: this.state.brand_color,
                            type: 'color',
                            required: false,
                            wrapperCustomClassName: 'form-group col-md-6 cursor-pointer',
                            customClassName: 'cursor-pointer'
                          },
                          {
                            label: 'Color Texto Marca',
                            id: 5,
                            state: 'text_brand_color',
                            value: this.state.text_brand_color,
                            type: 'color',
                            required: false,
                            wrapperCustomClassName: 'form-group col-md-6 cursor-pointer',
                            customClassName: 'cursor-pointer'
                          },
                          {
                            label: 'Color Primario',
                            id: 6,
                            state: 'primary_color',
                            value: this.state.primary_color,
                            type: 'color',
                            required: false,
                            wrapperCustomClassName: 'form-group col-md-6 cursor-pointer',
                            customClassName: 'cursor-pointer'
                          },
                          {
                            label: 'Color Texto Primario',
                            id: 7,
                            state: 'text_primary_color',
                            value: this.state.text_primary_color,
                            type: 'color',
                            required: false,
                            wrapperCustomClassName: 'form-group col-md-6 cursor-pointer',
                            customClassName: 'cursor-pointer'
                          },
                          {
                            label: 'Color Secundario',
                            id: 8,
                            state: 'secondary_color',
                            value: this.state.secondary_color,
                            type: 'color',
                            required: false,
                            wrapperCustomClassName: 'form-group col-md-6 cursor-pointer',
                            customClassName: 'cursor-pointer'
                          },
                          {
                            label: 'Color Texto Secundario',
                            id: 9,
                            state: 'text_secondary_color',
                            value: this.state.text_secondary_color,
                            type: 'color',
                            required: false,
                            wrapperCustomClassName: 'form-group col-md-6 cursor-pointer',
                            customClassName: 'cursor-pointer'
                          },
                        ]}
                        handleChange={this.handleChange}
                        wrapper={true}
                        onSubmit={saveColors}
                        secondaryButtonText={locales_es.resetColors}
                        onClickSecondaryButton={resetColors}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
          </div>
        </div>
        
        {result && (result === STATUS_SUCCESS || result === STATUS_FAILED) ?
          <ModalAnimationResult
            acceptAction={() => this.setState({result: null})}
            result={result}
            titleSuccess={'¡La operación ha sido exitosa!'}
            titleFailed={'Ha ocurrido un error. Inténtalo de nuevo más tarde.'}
          />
          : null
        }
      </div>
    
    )
  }
}
